// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3iHTv","item":"PaymentsMobile_item__CR_Tn","label":"PaymentsMobile_label__1mhp9","amount":"PaymentsMobile_amount__MbN-N"};